import React from 'react';

import { Modal, Button, Title, Group, Stack, Text } from '@mantine/core';
import useDeleteFile from 'hooks/athleteFile/useDeleteFile';
import notificationHandler from 'utils/notifications';

const FileDeleteModal = ({
  opened,
  fileId,
  toggleDrawer,
}: {
  opened: boolean;
  fileId: string;
  toggleDrawer: () => void;
}): JSX.Element => {
  const { successNotification, errorNotification } = notificationHandler();
  const deleteMutation = useDeleteFile();
  const handleClose = (): void => {
    if (opened) {
      toggleDrawer();
    }
  };

  const handleDelete = (): void => {
    deleteMutation.mutate(fileId, {
      onError: error => {
        errorNotification('File delete failed', error.response?.data.message);
      },
      onSuccess: () => {
        successNotification('File delete success', `File successfully deleted.`);
      },
    });
    handleClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {}}
      size='xs'
      centered
      title={<Title order={4}>Delete File</Title>}
    >
      <Stack p='md'>
        <Stack spacing={0}>
          <Text color='dimmed' size='sm'>
            Are you sure you want to delete this file?
          </Text>
        </Stack>
        <Group position='right'>
          <Button
            variant='light'
            size='xs'
            radius='md'
            onClick={handleClose}
            disabled={deleteMutation.isLoading}
          >
            Cancel
          </Button>
          <Button
            size='xs'
            radius='md'
            color='red'
            loading={deleteMutation.isLoading}
            onClick={handleDelete}
          >
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default FileDeleteModal;
